import { render, staticRenderFns } from "./AuthenticatedPhoto.vue?vue&type=template&id=1fe56ed6&scoped=true&class=wrap"
import script from "./AuthenticatedPhoto.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedPhoto.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticatedPhoto.vue?vue&type=style&index=0&id=1fe56ed6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe56ed6",
  null
  
)

export default component.exports